// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"538d8792","106":"4954f9bf","190":"ae094f5e","275":"2a5ab00a","307":"3d1d3868","324":"436409ec","334":"6d13c343","529":"7df3fa30","622":"2169fa6e","627":"2b547531","763":"40557c43","814":"86503771","880":"ac051430","926":"11eeee65","939":"ea38642f"}[chunkId] + ".chunk.js";
};